<div class="banner-image">
  <div class="banner-text-container">
  </div>
</div>

<div class="mt-4 mt-md-6 page-container container">
  <div class="row">
    <div class="header-container col-12 col-md-7">
      <h1 class="h2 my-0">{{"landing_page.header" | translate}}</h1>
      <div class="text--medium mt-4">
        {{"landing_page.description" | translate}}
      </div>
    </div>
  </div>
  <div *ngIf="electionsOverview" class="elections-container row justify-content-between mt-7">
    <div class="overview-container mt-4 mt-md-0 col-12 col-md-7">
      <h2 class="h3 mb-5">{{"landing_page.all_elections" | translate}}</h2>
      <mat-accordion class="section-content mb-4 d-block">
        <mat-expansion-panel *ngFor="let electionType of electionTypes">
          <mat-expansion-panel-header class="mat-header">
            <h3 class="text--f20">{{ electionType | enumTranslation: "ElectionType"}}</h3>
          </mat-expansion-panel-header>
          <ng-container *ngFor="let election of getElections(electionType), let last = last">
            <div class="mt-4">
              <div class="election-card__info">
                <div class="d-md-flex flex-wrap justify-content-between">
                  <h4 class="my-0">{{election.electionName}}&nbsp;{{election.electionDate | date : 'yyyy'}}</h4>
                  <button
                    class="mt-4 mt-md-0"
                    valgButton color="text-only-without-padding"
                    (click)="onSelectElectionClicked(election)"
                  > {{"landing_page.see_election_results" | translate}}</button>
                </div>
                <div class="text--small mt-1">{{formatElectionDate(election.electionDate)}} </div>
                <div class="text--medium mt-4 col-9 pl-0 pr-0" *ngIf="election.title">{{election.title}}</div>
              </div>
            </div>
            <hr *ngIf="!last">
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="active-elections-container col-12 col-md-5 col-lg-4" *ngIf="electionsOverview.activeElections && electionsOverview.activeElections.length > 0">
      <h2 class="h3 mb-5">{{"landing_page.active_elections" | translate}}</h2>
      <ng-container *ngFor="let election of electionsOverview.activeElections">
        <div class="card w-100 m-0 justify-content-between row mb-4">
          <div class="election-info">
            <div class="row justify-content-between m-0">
              <h3 class="m-0 text--f20 p-0">{{election.electionName}}</h3>
              <button
                (click)="onSelectElectionClicked(election)"
                color="icon"
                valgButton
                class="p-0">
                <mat-icon [svgIcon]="SvgIcon.Go"></mat-icon>
                <span class="sr-only">{{ 'landing_page.redirect_to_election_label' | translate: {election: election?.electionName} }}</span>
              </button>
            </div>
            <div class="text--small mt-1">{{formatElectionDate(election.electionDate)}} </div>
          </div>

        </div>
      </ng-container>
    </div>
  </div>
</div>
